import { soundEditionV1_2Abi } from '../abi/sound-edition-v1_2.mjs';

function editionContractInfo(client, {
  editionAddress
}) {
  return client.readContract({
    abi: soundEditionV1_2Abi,
    address: editionAddress,
    functionName: "editionInfo"
  });
}

export { editionContractInfo };
